<!--  保证金变动记录 -->
 
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left">
        <el-row style="margin: 10px  0 10px">
          <el-form-item label=""
                        prop="voucherCode">
            <el-input v-model.trim="formTool.voucherCode"
                      style="width: 200px;"
                      placeholder="请输入申请ID"
                      clearable
                      size="small" />
          </el-form-item>
          <el-form-item label="申请时间"
                        prop="date">
            <el-date-picker style="width: 240px;"
                            v-model="formTool.date"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            size="small"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间" />
          </el-form-item>
          <el-form-item label=""
                        prop="shopName">
            <el-input v-model.trim="formTool.shopName"
                      style="width: 200px;"
                      placeholder="请输入店铺信息"
                      clearable
                      size="small" />
          </el-form-item>
          <el-form-item label=""
                        prop="paymentStatus">
            <el-select v-model="formTool.paymentStatus"
                       clearable
                       style="width: 160px;"
                       size="small"
                       placeholder="请选择缴费状态">
              <el-option v-for="item in reasonOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small"
                       type="primary"
                       @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small"
                       @click="reset()">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small"
                       @click="exportUrl()">导出</el-button>
          </el-form-item>
        </el-row>

      </el-form>
    </div>

    <div class="center"
         style="position: relative"
         :style="contentHeight ? `height:${contentHeight}px!important` : ''">
      <MyTable :table-data="tableData"
               :index="index"
               :selection="selection"
               :page="page"
               :operation="operation"
               :table-option.sync="tableOption"
               @page-change="getList"
               @handleSelectionChange="handleSelectionChange">

        <template slot="paymentAmount"
                  slot-scope="scope">
          <span>
            {{ scope.row.paymentAmount ? String(scope.row.paymentAmount.toFixed(2)) : ''}}
          </span>
        </template>
        <template slot="paymentStatus"
                  slot-scope="scope">
          <span>
            {{ scope.row.paymentStatus == '0'?'未缴费':scope.row.paymentStatus == '1'?'审核中':scope.row.paymentStatus == '2'?'审核通过':scope.row.paymentStatus == '3'?'驳回':''}}
          </span>
        </template>
        <template slot="status"
                  slot-scope="scope">
          <el-link :underline="false"
                   type="primary"
                   class="btn"
                   @click="goDetail(scope.row)">查看凭证</el-link>
          <el-link :underline="false"
                   style="margin-left:16px"
                   type="primary"
                   class="btn"
                   @click="detailHandle(scope.row)">查看缴费明细</el-link>
        </template>
      </MyTable>
    </div>
    <!-- 查看明细 -->
    <addDialog ref="add-dialog"
               @getList="getList"
               :voucherId="voucherId" />
    <!-- 审核 -->
    <el-dialog title="查看打款凭证"
               :visible.sync="outerVisible">
      <el-dialog width="30%"
                 title="驳回原因"
                 :visible.sync="innerVisible"
                 append-to-body>
        <div>
          <el-input type="textarea"
                    style="margin-top: 10px;"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="remark">
          </el-input>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button size="small"
                     type="primary"
                     @click="agree(3)">确认驳回</el-button>
          <el-button size="small"
                     @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <div>
        <div>
          <el-image style="width: 100px; height: 100px;margin:10px"
                    v-for="item,index in srcList"
                    :key="index"
                    :src="item"
                    :preview-src-list="[item]">
          </el-image>
        </div>
        <div v-if="row.paymentStatus == 3">
          驳回原因
          <el-input type="textarea"
                    :disabled="true"
                    style="margin-top: 10px;"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="textarea">
          </el-input>
        </div>

      </div>
      <div slot="footer"
           class="dialog-footer">
        <div style="display: flex;justify-content: space-between;">
          <div>
            <span style="color: yellowgreen;"
                  v-if="row.paymentStatus == 1">凭证待审核</span>
            <span style="color: green;"
                  v-if="row.paymentStatus == 2">凭证已确认</span>
            <span style="color: red;"
                  v-if="row.paymentStatus == 3">凭证已驳回</span>
          </div>
          <div>
            <el-button v-if="row.paymentStatus == 1"
                       size="small"
                       type="primary"
                       @click="agree(2)">审批通过</el-button>
            <el-button v-if="row.paymentStatus == 1"
                       size="small"
                       type="primary"
                       @click="innerVisible = true">驳回</el-button>
            <el-button size="small"
                       @click="outerVisible = false">取 消</el-button>

          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
  
<script>
const reasonOptions = [
  {
    value: '0',
    label: '未缴费'
  },
  {
    value: '1',
    label: '审核中'
  },
  {
    value: '2',
    label: '审核通过'
  },
  {
    value: '3',
    label: '驳回'
  },

]

import MyTable from "@/components/myTable";
import addDialog from "./components/paymentMoney.vue";
import avater from "/public/img/default.png";
import { payvoucherinfo, excel, check } from "@/api/surety";
export default {
  components: { MyTable, addDialog },
  data () {
    return {
      // url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
      ],
      textarea: '',
      remark: '',
      row: {},
      outerVisible: false,
      innerVisible: false,
      voucherId: '',
      contentHeight: 0,
      activeName: 'first',
      avater: avater,
      formTool: {
        voucherCode: '',
        shopName: '',
        paymentStatus: '',
        date: []
      },
      operation: false,
      selection: false,
      index: true,
      tableData: [
      ],
      tableOption: [
        { label: "申请ID", prop: "voucherCode" },
        { label: "申请时间", prop: "createTime" },
        { label: "店铺名称", prop: "shopName" },
        { label: "缴款金额（元）", prop: "paymentAmount", slot: true },
        { label: "审核时间", prop: "updateTime", },
        { label: "缴费状态", prop: "paymentStatus", slot: true },
        { label: "操作", prop: "status", slot: true, width: '200px' },
      ],
      reasonOptions: reasonOptions,
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      dialogShow: false
    };
  },
  computed: {},
  filters: {
    filterReasonType (e) {
      for (let i = 0; i < reasonOptions.length; i++) {
        if (e == reasonOptions[i].value) return reasonOptions[i].label
      }
    },
  },
  watch: {},
  created () {
    this.getList();
  },
  mounted () { },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () {
    this.getWindowView()
  },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  computed: {

  },
  methods: {
    // 审核通过
    agree (type) {
      if (type == 3 && !this.remark) {
        this.$message.warning('请填写驳回原因')
        return
      }
      let params = {
        id: this.row.id,
        paymentStatus: type,
        voucherType: 1,
        remark: type == 3 ? this.remark : '',
      }
      check(params).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.outerVisible = false
          this.innerVisible = false
          this.getList()
        }
      })
    },
    //goDetail
    goDetail (row) {
      this.row = row
      this.textarea = row.remark
      this.srcList = row.voucherUrl.split(',')
      this.$nextTick(() => {
        this.outerVisible = true
      })
    },
    // 页码变化
    handleCurrentChange (e) {
      this.page.current = e
    },

    // 条数变化
    handleSizeChange (e) {
      this.page.size = e
      this.page.current = 1
    },
    //  查看明细
    detailHandle (row) {
      this.voucherId = row.id
      this.$nextTick(() => {
        this.$refs['add-dialog'].init()
      })

    },

    // 重置查询条件
    reset () {
      this.$refs.formTool.resetFields();
      this.getList(1);
    },
    // userLogExport
    // 导出
    exportUrl () {
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };
      if (this.formTool.date) {
        params.strTime = this.formTool.date[0];
        params.endTime = this.formTool.date[1];
      }
      excel(params).then(res => {
        console.log(res)
      })
    },
    // 搜索
    getList (current) {
      if (current) {
        this.page.current = current;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };
      if (this.formTool.date) {
        params.strTime = this.formTool.date[0];
        params.endTime = this.formTool.date[1];
      }
      delete params.date;
      payvoucherinfo(params).then((res) => {
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },

    // 勾选
    handleSelectionChange (val) {
      this.selectionList = val;
    },
    getWindowView () {
      let innerHeight = window.innerHeight; //获取页面高度 
      let headHeight = 60;
      headHeight = this.$refs['formTool'].$el.clientHeight; //获取子页面head 高度  
      console.log(headHeight, '--headHeight')
      let contentHeight = innerHeight - 238 - headHeight;
      this.contentHeight = contentHeight;
    }
  },
};
</script>
<style lang='scss' scoped>
.classification {
  .center {
    height: calc(100% - 112px);
  }
  .btn-warp {
    display: flex;
    justify-content: space-around;
  }
}

.btn-list {
  margin: 0 10px;
}
</style>
  